import FavoriteButton from '../FavoriteButton';
import { typeToLabel } from './GalleryResultPreview';
import PostTypeBadge from './PostTypeBadge';

export default function ContactListPreview({ item }) {
	let type = item?.contentType?.node?.graphqlSingleName;
	let typeLabel = typeToLabel(type);
	let id = item?.databaseId;

	if (
		item?.actorTypes?.nodes?.filter(o => o.name === 'Organisasjoner')
			.length > 0
	) {
		type = 'organization';
		typeLabel = 'Organisasjon';
	}

	console.log(item);

	const email = item?.actorFields?.email ?? item?.personFields?.workEmail;
	const phone = item?.actorFields?.phone ?? item?.personFields?.mobileNumber;

	if (!email && !phone) {
		return null;
	}

	return (
		<div class="flex flex-col gap-y-1 pt-4 pb-3 md:py-2.5 md:gap-y-0 lg:items-center border-gray border-b text-sm md:grid md:grid-cols-4 md:gap-x-5 sm:text-base">
			<div class="flex justify-between md:hidden w-full">
				<PostTypeBadge type={type} label={typeLabel} />
				<FavoriteButton id={id} />
			</div>
			<div class=" py-2 md:py-0 font-bold font-display lg:truncate">
				<a
					href={item?.link}
					class="no-underline hover:underline text-base"
				>
					{item?.title}
				</a>
			</div>
			<div class=" flex gap-x-1.5 lg:truncate">{phone}</div>
			<div class="flex gap-x-1.5">{email}</div>

			<div class="hidden md:flex md:items-start md:justify-end md:gap-x-1.5">
				<PostTypeBadge type={type} label={typeLabel} />
				<FavoriteButton id={id} />
			</div>
		</div>
	);
}
